// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hOoe","input":"styles_input__2iBZN"};